export const BACKEND_API_ROOT = process.env.REACT_APP_BACKEND_API_ROOT || 'http://localhost:3030';
export const BACKEND_API_VERSION = process.env.REACT_APP_BACKEND_API_VERSION || 'v1';
export const ADYEN_ENV = process.env.REACT_APP_ADYEN_ENV || 'test';
export const ADYEN_ORIGIN_KEY = process.env.REACT_APP_ADYEN_ORIGIN_KEY || '';
